import React, { useCallback } from 'react';
import { Form, Button } from 'react-bootstrap';
import { debounce } from 'lodash';
import { FilterIcon, SearchIcon } from "Assets/icons";

const DebouncedSearch = ({ value, placeholder = 'Search', defaultValue = '', onSearchChange, debounceTime = 500 }) => {
  const handleSearchChange = useCallback(debounce((e) => {
    if (onSearchChange) {
      onSearchChange(e.target.value);
    }
  }, debounceTime), [onSearchChange, debounceTime]);

  return (
    <div className="iconWithText position-relative h-100">
      <Form.Control
        type="search"
        placeholder={placeholder}
        className="search-input"
        aria-label="Search"
        defaultValue={defaultValue}
        onChange={handleSearchChange}
        style={{ height: "100%", border: 0 }}
      />
      <Button
        variant="transparent"
        className="border-0 icn p-0 position-absolute"
        style={{ left: 10 }}
      >
        <SearchIcon style={{height:"15px"}} />
      </Button>
      {/* <Button
        variant="transparent"
        className="border-0 icn p-0 position-absolute"
        style={{ right: 10 }}
      >
        <FilterIcon />
      </Button> */}
    </div>
  );
};

export default DebouncedSearch;
